'use client';
import { useTypedTranslation } from '@/hooks/useTypedTranslation';
import styles from './MerchantsFitsYourStore.module.css';

export default function MerchantsFitsYourStore() {
  const { t } = useTypedTranslation();

  return (
    <section className={styles.fitsYourStoreSection}>
      <div className={styles.backgroundContainer}>
        <div className={styles.contentContainer}>
          <h2 className={styles.heading}>{t('merchants.fitsYourStore.heading')}</h2>
          <p className={styles.subheading}>{t('merchants.fitsYourStore.subheading')}</p>
        </div>
      </div>
    </section>
  );
}
